import hash from 'object-hash'
import { decorators, CONSTANTS } from '@sohohouse/platform-resources'
import { platformGetters } from '~/helpers/store'
import { SEARCHES } from '../constants'
import filterGetters from './filters'

const Event = decorators.dh.Event
const { DateTime } = decorators.shared
const { DAY } = CONSTANTS.DATE_TIME_TYPES

export default {
  ...platformGetters,
  ...filterGetters,

  eventById: (_, getters) => id =>
    getters.resourceById(id) ? new Event(getters.resourceById(id)) : null,

  eventsBySearch: (_, getters) => params => {
    delete params.page

    const thisSearch = getters.getSearch(params)
    if (!thisSearch) {
      return []
    }

    return thisSearch.pages.reduce(
      (acc, thisPage) => [...acc, ...thisPage.map(eventId => {
        const event = new Event(getters.resourceById(eventId))
        return event
      })],
      []
    )
  },

  getSearch: ({ meta }, getters) => params => {
    const withEventViewFilters = getters.applyEventViewFilters(params)
    const hashedSearch = hash(withEventViewFilters)
    return meta.searches[hashedSearch]
  },

  featuredEvents: (_, getters) => eventView => getters.eventsBySearch({ eventView, params: SEARCHES.FEATURED }),
  historyEvents: (_, getters) => eventView => getters.eventsBySearch({ eventView, params: SEARCHES.HISTORY }),
  allEvents: (_, getters) => eventView => getters.eventsBySearch({ eventView, params: SEARCHES.ALL }),

  inductionEvents: (_, getters, __, globalGetters) => {
    const date = new DateTime()
    const localVenue = globalGetters['user/account/localHouse']

    if (!localVenue.id) return []

    return Object.values(getters.resources)
      .map(event => new Event(event))
      .filter(e =>
        e.startsAt.isAfter(date) &&
        e.bookable === CONSTANTS.EVENT_BOOKABLE.IS_BOOKABLE &&
        e.resource.resourceType === CONSTANTS.EVENT_TYPES.INDUCTION &&
        e.venue.id === localVenue.id &&
        e.state === CONSTANTS.EVENT_STATES.OPEN_FOR_BOOKING
      )
  },

  inductionSevenDayEvents: (s, getters) => {
    const events = getters.inductionEvents
    const date = new DateTime()
    return events.filter(e => date.diff(e.startsAt, DAY) <= 8)
  },

  inductionThirtyDayEvents: (_, getters) => {
    const events = getters.inductionEvents
    const date = new DateTime()
    return events.filter(e =>
      date.diff(e.startsAt, DAY) <= 30 &&
      date.diff(e.startsAt, DAY) > 8
    )
  },
  inductionEventsFetching: s => s.meta.inductionEventsFetching,

  happeningNowFetching: ({ meta }) => meta.searches.happeningNowFetching,

  happeningNowFailed: ({ meta }) => meta.searches.happeningNowFailed,

  happeningNow: ({ meta }) => {
    const { happeningNow } = meta.searches

    return happeningNow ? happeningNow.map(e => new Event(e)) : []
  },

  pastEvents: ({ meta }) => meta.searches.pastEvents || []
}
